export const apiUrl = {
    tokenValidate: "/portalPreview?",
    saveDeskPortalClicks: "/saveDeskPortalClicks",
    getPrices: "/getPrices?",
    createFBTrackableLink: "/CreateFBTrackableLink?",
    fetchReportingHubAuthorizeUrl: "/fetchReportingHubAuthorizeUrl",
    fetchReportingHubUser: "/GetRepotingHubUser",
    fetchToken: "/FetchToken",
};
